import types from '../types'

const changeOriginLongName = (st) => ({
  type: types.ORIGIN_LONGNAME_CHANGE,
  payload: st,
})

const changeDestinationLongName = (st) => ({
  type: types.DESTINATION_LONGNAME_CHANGE,
  payload: st,
})

const changeOriginShortName = (st) => ({
  type: types.ORIGIN_SHORTNAME_CHANGE,
  payload: st,
})

const changeDestinationShortName = (st) => ({
  type: types.DESTINATION_SHORTNAME_CHANGE,
  payload: st,
})

const changeOriginGooglePlaceId = (st) => ({
  type: types.ORIGIN_GOOGLE_PLACE_ID_CHANGE,
  payload: st,
})

const changeDestinationGooglePlaceId = (st) => ({
  type: types.DESTINATION_GOOGLE_PLACE_ID_CHANGE,
  payload: st,
})

export default {
  changeOriginLongName,
  changeDestinationLongName,
  changeOriginShortName,
  changeDestinationShortName,
  changeOriginGooglePlaceId,
  changeDestinationGooglePlaceId,
}
